'use strict'

module.exports.DATETIME = 'datetime'
